module.exports = __webpack_public_path__ + "static/media/wizualizacja-50.52e2189e.png";